import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../rootReducers";

const selectLightStates = (state: RootState) => state.lightStates;

export const getLightStatesNodes = createSelector(
    selectLightStates,
    (state) => state.nodes
);

export const getLightStatesFetching = createSelector(
    selectLightStates,
    (state) => state.isFetching
);
